import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      group: "shared",
      animation: 150,
      onEnd: this.end.bind(this),
    });
  }

  end(event) {
    let id = event.item.dataset.id;
    let data = new FormData();
    //add 1 to the index as acts_as_list starts at 1
    data.append("position", event.newIndex + 1);

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;

    fetch(this.data.get("url").replace(":id", id), {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken,
        Accept: "text/html",
      },
      body: data,
    });
  }
}
